import { asyncThunkCreator, buildCreateSlice } from '@reduxjs/toolkit';

/**
 * Creates a slice that can contain async thunks.
 */
const createAsyncSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export default createAsyncSlice;
